import React, { useState } from 'react';
import { Tooltip } from 'antd';
import RenameModal from './RenameModal';
import { EditOutlined } from '@ant-design/icons';
import { useDocument } from '../../context/documentInfoContex';
import './styles.css';

const DocumentTitle = ({ isMobile }) => {
    const { documentInfo, templateData, isTemplateDocument, isReadOnly } = useDocument();
    const [renameModalVisible, setRenameModalVisible] = useState(false);
    const name = isTemplateDocument ? (templateData ? templateData.name : "Template") : (documentInfo ? documentInfo.name : "New Board");

    return (
        <>
            <div className="document-title-container">
                <h1 className={`document-title-h1 ${isMobile ? 'mobile' : ''}`}>
                    {name}
                </h1>
                {!isReadOnly && (
                    <Tooltip title="Rename">
                        <span className={`document-title-edit-icon ${isMobile ? 'mobile' : ''}`}
                            onClick={() => setRenameModalVisible(true)}
                        >
                            <EditOutlined />
                        </span>
                    </Tooltip>
                )}
            </div>
            <RenameModal
                visible={renameModalVisible}
                onClose={() => setRenameModalVisible(false)}
            />
        </>
    );
};

export default DocumentTitle;